import * as React from 'react';

import CircleCloseButton24 from './CircleCloseButton24';

export const circleCloseButton24 = () => <CircleCloseButton24 />;

export default {
    title: 'Icon/Fill/CircleCloseButton24',
    component: CircleCloseButton24,
    parameters: {
        notes: "`import CircleCloseButton24 from 'box-ui-elements/es/icon/fill/CircleCloseButton24';`",
    },
};
